import React from "react";
import { TbCheck } from "react-icons/tb";
import CustomButton from "../CustomButton/CustomButton";
import styles from "./PlanCard.module.css";

const PlanCard = ({
  planName,
  badgeText,
  badgeVariant = "success",
  priceLabel,
  price,
  billingCycle = "per year",
  subText,
  billingNote,
  description,
  limitsTitle = "USER LIMITS & STORAGE",
  limits = [],
  slabTitle,
  slabs = [],
  selectedSlabId,
  onSlabChange,
  includesTitle = "INCLUDES",
  includes = [],
  amc,
  ctaText,
  onCtaClick,
  highlighted = false,
  className = "",
}) => {
  return (
    <div
      className={`${styles.card} ${
        highlighted ? styles.cardHighlighted : ""
      } ${className}`}
    >
      <div className={styles.headerRow}>
        <span className={styles.planName}>{planName}</span>
        {badgeText && (
          <span className={`${styles.badge} ${styles[badgeVariant]}`}>
            {badgeText}
          </span>
        )}
      </div>

      {priceLabel && <span className={styles.priceLabel}>{priceLabel}</span>}

      <div className={styles.priceRow}>
        <span className={styles.price}>{price}</span>
        {billingCycle && (
          <span className={styles.billingCycle}>/ {billingCycle}</span>
        )}
      </div>

      {subText && <p className={styles.subText}>{subText}</p>}
      {billingNote && <p className={styles.billingNote}>{billingNote}</p>}

      {description && <p className={styles.description}>{description}</p>}

      <div className={styles.divider} />

      {slabs.length > 0 && (
        <div className={styles.slabSection}>
          {slabTitle && <span className={styles.slabTitle}>{slabTitle}</span>}
          <div className={styles.slabList}>
            {slabs.map((slab) => {
             const checked = slab.id === selectedSlabId;
              return (
                <label
                  key={slab.id}
                  className={`${styles.slabRow} ${
                    checked ? styles.slabRowChecked : ""
                  }`}
                >
                  <span className={styles.slabRowLeft}>
                    <input
                      type="radio"
                      name={`slab-${planName}`}
                      className={styles.slabRadio}
                      checked={checked}
                      onChange={() => onSlabChange && onSlabChange(slab.id)}
                    />
                    <span className={styles.slabLabel}>{slab.label}</span>
                  </span>
                  <span className={styles.slabPrice}>{slab.price}</span>
                </label>
              );
            })}
          </div>
        </div>
      )}

      {limits.length > 0 && (
        <div className={styles.limitsSection}>
          <span className={styles.limitsTitle}>{limitsTitle}</span>
          <ul className={styles.limitsList}>
            {limits.map((limit, index) => (
              <li key={index} className={styles.limitItem}>
                {limit}
              </li>
            ))}
          </ul>
        </div>
      )}

      {includes.length > 0 && (
        <div className={styles.includesSection}>
          {includesTitle && (
            <span className={styles.includesTitle}>{includesTitle}</span>
          )}
          <ul className={styles.includesList}>
            {includes.map((item, index) => (
              <li key={index} className={styles.includesItem}>
                <TbCheck className={styles.includesIcon} />
                <span>{item}</span>
              </li>
            ))}
          </ul>
        </div>
      )}

      {amc && (amc.text || amc.label) && (
        <div className={styles.amcBox}>
          {amc.label && amc.price ? (
            <>
              <span
                style={{
                  fontSize: "13px",
                  fontWeight: 400,
                  color: "#1D4ED8",
                  marginBottom: "4px",
                }}
              >
                {amc.label}
              </span>
              <span
                style={{
                  paddingLeft: "3px",
                  fontSize: "15px",
                  fontWeight: 800,
                  color: "#1D4ED8",
                  marginBottom: "10px",
                }}
              >
                {amc.price}
              </span>
            </>
          ) : (
            <span className={styles.amcText}>{amc.text}</span>
          )}
          {amc.includes?.length > 0 && (
            <>
              <span className={styles.amcIncludesTitle}>INCLUDES</span>
              <ul className={styles.includesList}>
                {amc.includes.map((item, index) => (
                  <li key={index} className={styles.includesItem}>
                    <TbCheck className={styles.includesIcon} />
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
            </>
          )}
        </div>
      )}

      {ctaText && (
        <CustomButton
          variant="primary"
          onClick={onCtaClick}
          className={styles.ctaButton}
          rounded
        >
          {ctaText}
        </CustomButton>
      )}
    </div>
  );
};

export default PlanCard;
